/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverPaymentPeriodFormPeriodLength: "driver-payment-period-form-period-length",
  driverPaymentPeriodFormPeriodUnit: "driver-payment-period-form-period-unit",
  driverPaymentPeriodFormPeriodUnitOption: "driver-payment-period-form-period-unit-option",
} as const;
